import { render, staticRenderFns } from "./DeadlineNew.vue?vue&type=template&id=67ba626e"
import script from "./DeadlineNew.vue?vue&type=script&lang=js"
export * from "./DeadlineNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports